import { Directive, Input, Renderer, ElementRef } from "@angular/core";

@Directive({
    selector: '[cellFocus]'
})
export class CellFocus {
    constructor(public renderer: Renderer, public elementRef: ElementRef) { }

    @Input()
    set cellFocus(value: boolean) {
        if (value) {
            this.renderer.invokeElementMethod(
                this.elementRef.nativeElement, 'focus', []);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/offer-entry-grid/cellFocus.ts